<template>
  <div class="container container_40">
    <div class="container__no-data">
      <md-icon class="md-size-4x">{{ icon }}</md-icon>
      <div class="text_large">{{ title }}</div>
      <div class="text_description text_margin text_medium">{{ descr }}</div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'not-available',
    props: {
      icon: { type: String, required: true },
      title: { type: String, required: true },
      descr: { type: String, required: true }
    }
  }
</script>



// WEBPACK FOOTER //
// src/vue/app/common/NotAvailableCard.vue